import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type ShiftExtensionResponse = {
  date_created: string
}

export function useAcceptShiftExtension() {
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post<ShiftExtensionResponse[]>('/int/v3/shift/extensions')
      return data
    },
  })
}
